/* eslint-disable jsx-a11y/anchor-is-valid */
import { Avatar, TopBar } from '@osttra/ds-react';
import logo from '../../../images/logo.png';
import { useContext, useState } from 'react';
import { AboutOsttraModal, CustomerSupportConfig } from '@osttra/osttra-ui-widgets';
import EnvironmentContext from '../../../context/EnvironmentContext';
import './Header.scss';

const customerSupportConfig: CustomerSupportConfig = {
  title: 'OSTTRA Client Services',
  supportLink: 'https://osttra.com/support/',
};
const Header = (props: { userName: string; userParentOrg: string }) => {
  const [isVisibleAbout, setIsVisibleAbout] = useState<boolean>(false);

  const userIDSplit = props.userName.split('@');
  const userNameSelect = userIDSplit[0].split('.');
  const firstName = userNameSelect[0];
  const secName = userNameSelect[1] ? userNameSelect[1] : '';
  const firstNameFistChar = firstName?.charAt(0);
  const lastNameFistChar = secName?.charAt(0);
  const env = useContext(EnvironmentContext);

  return (
    <>
      {isVisibleAbout ? (
        <AboutOsttraModal onClose={() => setIsVisibleAbout(false)} supportInfo={customerSupportConfig} />
      ) : null}
      <TopBar
        logo={<TopBar.Logo href="https://osttra.com/" image={logo} productName="Osttra Platform" />}
        environment={env}
        className="platform-app-header"
        menuRight={
          <TopBar.DropDown
            id={'account-settings'}
            title={props.userName}
            avatar={
              firstNameFistChar && lastNameFistChar ? (
                <Avatar initials={`${firstNameFistChar}${lastNameFistChar}`} />
              ) : null
            }
            subTitle={props.userParentOrg}
            showDropDownCaret={false}
          ></TopBar.DropDown>
        }
        help={
          <TopBar.DropDown id="help-dropdown" title="Help" showDropDownCaret={true} className="top-help">
            <TopBar.Menu align="right">
              <TopBar.Item
                className="help-menu"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setIsVisibleAbout(true);
                }}
              >
                About OSTTRA
              </TopBar.Item>
            </TopBar.Menu>
          </TopBar.DropDown>
        }
      />
    </>
  );
};

export default Header;
